<script>
  import { TabPane } from 'element-ui'
  export default {
    name:'ElTabPane',
    extends:TabPane
  }
</script>
